'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  ['\n  text-decoration: ', ';\n'],
  ['\n  text-decoration: ', ';\n']
)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Link = _Text2.default
  .withComponent('a')
  .extend(_templateObject, function(props) {
    return props.underline ? 'underline' : 'none'
  })

Link.displayName = 'Link'

Link.propTypes = {
  href: _propTypes2.default.string,
  underline: _propTypes2.default.bool
}

Link.defaultProps = {
  theme: _theme2.default,
  color: 'info',
  underline: false
}

exports.default = Link



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Link.js
// module id = 178
// module chunks = 168707334958949